import { ISchema, PaywallComponentProps } from '../@types'
import { mergeDeep } from '@/helpers/utils'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				scratchCardModal: true,
				initialDiscount: false,
				countdown: { autoStart: false },
			},
			order: [...schema.order, 'PaywallScratchCardModal'],
			components: {
				PaywallTitle: ({ $t, ctx }): PaywallComponentProps.Title => ({
					title: ctx.removeDiscount
						? $t('male-tai-chi-yoga.paywall.title')
						: `Grab your Personal Tai Chi plan—<span class="text-attention">NOW 75% OFF!</span>`,
					textAlignment: 'center',
					customStyles: {
						marginLeft: '20px',
						marginRight: '20px',
					},
				}),
				PaywallScratchCardModal: ({ $t }): PaywallComponentProps.ScratchCardModal => ({
					subtitle: $t('pages.program.scratch_card.subtitle'),
					revealedContent: {
						primary: $t('pages.program.scratch_card.revealed_content.primary', { discount: 75 }),
						secondary: 'on your Personal Plan',
					},
				}),
			},
		},
	)
